/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */

import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import CheckmarkIcon from "../../icons/CheckmarkIcon";
import Helmet from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

const PaymentSuccess = () => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const [loading, setLoading] = useState(false);
	useEffect(async () => {
		setLoading(true);
		await queryClient.refetchQueries(["auth-user"])
		setLoading(false);
	}, []);

	const goToDashboard = useCallback(() => {
		navigate("/profile/dashboard");
	}, [navigate]);
	return (
		<Row as="main" className="sign-up">
			<Helmet>
				<title>
					{"EQQO Account Created"}
				</title>
			</Helmet>

			<Col className="create-account flow" fluid="true">
				<img
					alt="LOGO" className="logo" height="152" src="/eqqo_logo_blue.png"
					width="472"
				/>
				<Container className="bg-white flow wrapper text-center">
					<CheckmarkIcon background={"var(--bs-success"} />
					<h1 className="my-4">Payment Successful</h1>
					<p>Thanks, we've received your payment. You'll receive your receipt via email.</p>
					<p>When you're ready, proceed to begin your EQQO Profile.</p>
					<Button className="btn-gradient" disabled={loading} onClick={goToDashboard}>
						{loading ? <Spinner animation="border" size="sm" /> : "Start My Assessment"}
					</Button>
				</Container>
			</Col>
		</Row>
	);
}

export default PaymentSuccess;
